import type {
  ProductInfo,
  VariantInfo,
} from "@redotech/redo-product-common/product";
import { getShopifyProductDetailPageUrl } from "@redotech/redo-product-common/product";

export interface ProductLinkSelection {
  readonly text: string;
  readonly url: string;
}

export function getProductLinkSelection({
  product,
  storeUrl,
  variant,
}: {
  product: Pick<ProductInfo, "handle" | "name">;
  storeUrl: string;
  variant?: Pick<VariantInfo, "id">;
}): ProductLinkSelection | null {
  if (!product.handle) {
    return null;
  }

  return {
    text: product.name,
    url: getShopifyProductDetailPageUrl(storeUrl, product.handle, variant?.id),
  };
}
